<template>
  <div class="hello">
    <h1>Welcome!</h1>
    <p>
      Kentwood Summer Doubles is now a non-profit organization!!! We look
      forward to another great year in 2019.
    </p>
    <v-layout wrap v-for="(tier, key) in sponsors" v-bind:key="key">
      <v-flex xs12>
        <h2>{{ key.toUpperCase() }} Sponsors</h2>
      </v-flex>
      <v-flex xs12>
        <v-card
          class="sponsor-card ma-2"
          v-for="sponsor in tier"
          v-bind:key="sponsor.name"
          :href="sponsor.url"
          target="_blank"
        >
          <v-img :src="sponsor.src" :contain="true" height="300"></v-img>
          <v-card-title primary-title class="subheading">{{
            sponsor.name
          }}</v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <p class="caption">*To become a sponsor, contact Micheal Kirsch</p>
  </div>
</template>

<script>
import SPONSORS from "./shared/data/sponsors";

export default {
  name: "home",
  data() {
    return {
      sponsors: SPONSORS.reduce((result, sponsor) => {
        const tier = (result[sponsor.tier] = result[sponsor.tier] || []);
        tier.push(sponsor);
        return result;
      }, {}),
    };
  },
};
</script>

<style scoped>
.sponsor-card {
  width: 300px;
  display: inline-block;
}
</style>
